<template>
  <AdPageUnavailable :path="['decor.scenarios', 'decor.scenarios.actors']">
    <v-layout>
      <v-flex>
        <ActorPanel></ActorPanel>
      </v-flex>
    </v-layout>
  </AdPageUnavailable>
</template>

<script>
import ActorPanel from '@/components/Scenario/ActorPanel'

export default {
  name: 'AdActor',
  components: {
    ActorPanel
  }
}
</script>
